// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const klefki: PokeData = {
  "id": 707,
  "name": "klefki",
  "height": 2,
  "weight": 30,
  "base_experience": 165,
  "types": [
    PokeType.STEEL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "spikes",
    "torment",
    "recycle",
    "imprison",
    "astonish",
    "metal-sound",
    "heal-block",
    "last-resort",
    "mirror-shot",
    "flash-cannon",
    "magic-room",
    "foul-play",
    "draining-kiss",
    "crafty-shield",
    "play-rough",
    "fairy-wind",
    "fairy-lock"
  ],
  "moves": [
    "tackle",
    "metal-sound",
    "play-rough",
    "sweet-kiss",
    "magnet-pull",
    "moonblast",
    "behemoth-bash",
    "gear-up",
    "steel-beam",
    "iron-defense",
    "guardian-bond",
    "heal-bell",
    "misty-terrain"
  ],
  "evolution_chain": {
    "id": 363,
    "item": null,
    "species": [
      {
        "name": "klefki",
        "order": 707,
        "types": [
          PokeType.STEEL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 132,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
